import React from 'react'
import { useSortable } from './analyticsHelpers'

export function KpiCard({ label, value, sub, accent = false }: {
  label: string; value: string; sub?: string; accent?: boolean
}) {
  return (
    <div className={`rounded-xl border p-4 shadow-sm ${accent ? 'bg-indigo-600 border-indigo-500 text-white' : 'bg-white border-gray-200'}`}>
      <p className={`text-xs font-semibold uppercase tracking-wider mb-1 ${accent ? 'text-indigo-200' : 'text-gray-500'}`}>
        {label}
      </p>
      <p className={`text-2xl font-bold ${accent ? 'text-white' : 'text-gray-900'}`}>{value}</p>
      {sub && <p className={`text-xs mt-0.5 ${accent ? 'text-indigo-200' : 'text-gray-400'}`}>{sub}</p>}
    </div>
  )
}

export function EmptyChart() {
  return (
    <div className="flex items-center justify-center h-48 text-sm text-gray-400">
      No data for this period
    </div>
  )
}

export function SectionTitle({ children }: { children: React.ReactNode }) {
  return <h2 className="text-sm font-semibold text-gray-700 uppercase tracking-wider">{children}</h2>
}

export function SortableTh<T>({ col, right, children, sortKey, sortDir, onToggle }: {
  col: keyof T
  right?: boolean
  children: React.ReactNode
  sortKey: keyof T
  sortDir: 'asc' | 'desc'
  onToggle: (col: keyof T) => void
}) {
  return (
    <th
      onClick={() => onToggle(col)}
      className={`px-4 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider cursor-pointer hover:text-gray-900 select-none whitespace-nowrap ${right ? 'text-right' : 'text-left'}`}
    >
      {children}{sortKey === col ? (sortDir === 'asc' ? ' ↑' : ' ↓') : ''}
    </th>
  )
}

export { useSortable }
